import React from 'react';
import Icon from '../AppIcon';

const AIMatchNotification = ({ notification, onClose, currentLanguage = 'en' }) => {
  const translations = {
    en: {
      newMatch: 'New AI Match',
      rematched: 'Delivery Rematched',
      matchFailed: 'Match Failed',
      delay: 'Delivery Delay',
      matchScore: 'Match Score',
      viewDetails: 'View Details',
      close: 'Close'
    },
    ko: {
      newMatch: '새로운 AI 매칭',
      rematched: '배송 재매칭',
      matchFailed: '매칭 실패',
      delay: '배송 지연',
      matchScore: '매칭 점수',
      viewDetails: '상세보기',
      close: '닫기'
    }
  };
  
  const t = translations?.[currentLanguage] || translations?.en;
  
  const getIcon = () => {
    switch (notification?.type) {
      case 'NEW_AI_MATCH':
        return { name: 'Sparkles', color: '#10b981' };
      case 'EMERGENCY_REMATCH':
        return { name: 'RefreshCw', color: '#f59e0b' };
      case 'REMATCH_FAILED':
        return { name: 'AlertCircle', color: '#ef4444' };
      case 'DELAY_NOTIFICATION':
        return { name: 'Clock', color: '#f59e0b' };
      default:
        return { name: 'Bell', color: '#6366f1' };
    }
  };
  
  const getTitle = () => {
    switch (notification?.type) {
      case 'NEW_AI_MATCH':
        return t?.newMatch;
      case 'EMERGENCY_REMATCH':
        return t?.rematched;
      case 'REMATCH_FAILED':
        return t?.matchFailed;
      case 'DELAY_NOTIFICATION':
        return t?.delay;
      default:
        return notification?.title;
    }
  };
  
  const icon = getIcon();
  
  return (
    <div className="fixed bottom-20 right-4 md:right-8 max-w-md bg-white rounded-lg shadow-elevation-lg border border-gray-200 p-4 animate-slide-up z-50">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: `${icon?.color}20` }}>
            <Icon name={icon?.name} size={20} color={icon?.color} />
          </div>
        </div>
        
        <div className="flex-1">
          <h4 className="font-semibold text-foreground mb-1">{getTitle()}</h4>
          <p className="text-sm text-gray-600 mb-2">{notification?.message}</p>
          
          {notification?.metadata?.matchScore && (
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xs font-medium text-gray-500">{t?.matchScore}:</span>
              <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div 
                  className="h-full bg-primary rounded-full transition-all duration-300"
                  style={{ width: `${(notification?.metadata?.matchScore * 100)}%` }}
                />
              </div>
              <span className="text-xs font-semibold text-primary">
                {(notification?.metadata?.matchScore * 100)?.toFixed(0)}%
              </span>
            </div>
          )}
          
          {notification?.metadata?.alternatives && notification?.metadata?.alternatives?.length > 0 && (
            <div className="mt-2 p-2 bg-yellow-50 rounded text-xs text-yellow-700">
              <p className="font-medium mb-1">Alternatives:</p>
              <ul className="space-y-1">
                {notification?.metadata?.alternatives?.slice(0, 2)?.map((alt, idx) => (
                  <li key={idx}>• {alt?.suggestion}</li>
                ))}
              </ul>
            </div>
          )}
          
          <div className="flex gap-2 mt-3">
            {notification?.dealId && (
              <button
                onClick={() => window.location.href = `/deal-room-page?dealId=${notification?.dealId}`}
                className="text-xs font-medium text-primary hover:text-primary-dark transition-colors"
              >
                {t?.viewDetails} →
              </button>
            )}
            <button
              onClick={onClose}
              className="ml-auto text-xs font-medium text-gray-500 hover:text-gray-700 transition-colors"
            >
              {t?.close}
            </button>
          </div>
        </div>
        
        <button
          onClick={onClose}
          className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <Icon name="X" size={16} />
        </button>
      </div>
    </div>
  );
};

export default AIMatchNotification;